import { Component } from '@angular/core';
import { RedirectStrategy } from './redirect-strategy.model';
import { RedirectRule } from './redirect-rule.model';
import { BreadcrumbService } from '../../../../breadcrumb.service';
import { RouterConst } from '../../../../globals/RoutersConst';
import { isUndefined } from 'util';
import { ClientsService } from '../../../../services/clients/clients.service';
import { CookieService } from 'ngx-cookie-service';
import { HttpClient } from '@angular/common/http';
import { DashboardDataService } from '../../../../services/dashboard-data.service';
import { WsService } from '../../../../services/websocket/WsService';
import { SuperClass } from '../../../../superclass/SuperClass';
import {
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';

@Component({
  selector: 'app-redirect-startegies',
  templateUrl: './redirect-startegies.component.html',
  styleUrls: ['./redirect-startegies.component.css'],
})
export class RedirectStrategiesComponent extends SuperClass {
  redirectStrategies: RedirectStrategy[];
  redirectStrategyRules: RedirectRule[];

  selectedStrategy: RedirectStrategy;
  selectedRule: RedirectRule;

  deviceTypes;
  periodsOfDay;
  periodsOfDayStart;
  periodsOfDayEnd;
  daysOfWeek;

  newRuleForm: FormGroup;
  selectedRuleForm: FormGroup;
  newStrategyForm: FormGroup;
  selectedStrategyForm: FormGroup;

  newStrategy: RedirectStrategy;
  newRule: RedirectRule;

  displayStrategy = false;
  displayRule = false;
  PERIOD_START_ANY = -1;

  constructor(
    private breadcrumbService: BreadcrumbService,
    private dashboardDataService: DashboardDataService,
    private clientsService: ClientsService,
    private wsService: WsService,
    private httpClient: HttpClient,
    private cookiesService: CookieService,
    private fb: FormBuilder,
  ) {
    super(
      clientsService,
      wsService,
      dashboardDataService,
      httpClient,
      cookiesService,
    );

    this.breadcrumbService.setItems([
      { label: 'Organization' },
      { label: 'Captive Portal' },
      {
        label: 'Redirect Strategies',
        routerLink: [{ outlets: { sub: [RouterConst.REDIRECT_CHANGES] } }],
      },
    ]);
    this.newStrategy = new RedirectStrategy();
    this.newRule = new RedirectRule();
  }

  reloadData() {
    this.http_getRedirectStrategies((data: any) => {
      this.redirectStrategies = data.payload;
    });

    this.http_getStrategyPeriodOfDay((data: any) => {
      this.periodsOfDay = data.payload;
      this.periodsOfDayEnd = data.payload;
      this.periodsOfDayStart = data.payload.filter(function(el) {
        return el.id !== 24;
      });
    });

    this.http_getStrategyDayOfWeek((data: any) => {
      this.daysOfWeek = data.payload;
    });

    this.http_getStrategyDeviceType((data: any) => {
      this.deviceTypes = data.payload;
    });

    this.selectedRuleForm = this.fb.group({
      dayOfWeek: new FormControl('', Validators.required),
      periodStart: new FormControl('', Validators.required),
      periodEnd: new FormControl('', Validators.required),
      deviceType: new FormControl('', Validators.required),
      redirect: new FormControl('', Validators.required),
      numberOfLogin: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
        ]),
      ),
      redirectOptIn: new FormControl('', Validators.required),
    });

    this.newRuleForm = this.fb.group({
      dayOfWeek: new FormControl('', Validators.required),
      periodStart: new FormControl('', Validators.required),
      periodEnd: new FormControl('', Validators.required),
      deviceType: new FormControl('', Validators.required),
      redirect: new FormControl('', Validators.required),
      numberOfLogin: new FormControl(
        '',
        Validators.compose([
          Validators.required,
          Validators.pattern('^[0-9]+$'),
          Validators.max(2147483647),
        ]),
      ),
      redirectOptIn: new FormControl('', Validators.required),
    });

    this.newStrategyForm = this.fb.group({
      name: new FormControl('', Validators.required),
    });

    this.selectedStrategyForm = this.fb.group({
      name: new FormControl('', Validators.required),
    });
  }

  selectStrategyRow(e) {
    this.selectedStrategy = new RedirectStrategy(e.data);
    this.http_getStrategyRules(this.selectedStrategy.id, (data: any) => {
      this.loadRulesFromResponse(data);
    });
  }

  selectRuleRow(e) {
    this.selectedRule = new RedirectRule(e.data);
    this.periodStartChanged(this.selectedRule.periodStart);
  }

  addStrategy() {
    this.displayStrategy = true;
  }

  createNewStrategy() {
    const requiredFields = [
      { id: 'new_name', value: this.newStrategy.name, fieldName: 'Name' },
    ];
    if (this.hasEmptyFields(requiredFields)) {
      return;
    }

    this.http_addRedirectStrategy(this.newStrategy, (data: any) => {
      this.showSuccessMessage('Strategy has been created');
      this.redirectStrategies = data.payload;
    });
    this.displayStrategy = false;
  }

  deleteStrategy() {
    this.http_removeRedirectStrategy(this.selectedStrategy, (data: any) => {
      this.showSuccessMessage('Strategy has been deleted');
      this.redirectStrategies = data.payload;
    });
  }

  saveStrategy() {
    this.http_updateRedirectStrategy(this.selectedStrategy, (data: any) => {
      this.showSuccessMessage('Strategy has been updated');
      this.redirectStrategies = data.payload;
    });
  }

  addRule() {
    this.displayRule = true;
  }

  createNewRule() {
    this.newRule.strategyId = this.selectedStrategy.id;

    const conflictingRule = this.findConfiltingRule(this.newRule);
    if (!isUndefined(conflictingRule)) {
      this.showMessage(
        'error',
        'Conflicting Rule exists',
        'Rule with same day of week, device type, number of login ' +
          'and period from ' +
          conflictingRule.periodStart.description +
          ' to ' +
          conflictingRule.periodEnd.description,
      );
      return;
    }

    this.http_addStrategyRule(this.newRule, (data: any) => {
      this.showSuccessMessage('Rule has been created');
      this.loadRulesFromResponse(data);
    });
    this.newRuleForm.reset();
    this.displayRule = false;
  }

  deleteRule() {
    this.http_removeStrategyRule({ id: this.selectedRule.id }, (data: any) => {
      this.showSuccessMessage('Rule has been deleted');
      this.loadRulesFromResponse(data);
    });
  }

  saveRule() {
    const coflictingRule = this.findConfiltingRule(this.selectedRule);
    if (!isUndefined(coflictingRule)) {
      this.showMessage(
        'error',
        'Conflicting Rule exists',
        'Rule with same day of week, device type, number of login ' +
          'and period from ' +
          coflictingRule.periodStart.description +
          ' to ' +
          coflictingRule.periodEnd.description,
      );
      return;
    }

    this.http_updateStrategyRule(this.selectedRule, (data: any) => {
      this.showSuccessMessage('Rule has been updated');
      this.loadRulesFromResponse(data);
    });
  }

  periodStartChanged(e) {
    const periodStartId = isUndefined(e)
      ? this.selectedRule.periodStart.id
      : e.id;
    if (periodStartId === this.PERIOD_START_ANY) {
      this.selectedRule.periodEnd = this.periodsOfDay.filter(function(el) {
        return el.id === periodStartId;
      })[0];
      this.periodsOfDayEnd = [this.selectedRule.periodEnd];
    } else {
      this.periodsOfDayEnd = this.periodsOfDay.filter(function(el) {
        return el.id > periodStartId;
      });
    }
  }

  periodStartNewChanged() {
    const periodStartId = this.newRule.periodStart.id;
    if (periodStartId === this.PERIOD_START_ANY) {
      this.newRule.periodEnd = this.periodsOfDay.filter(function(el) {
        return el.id === periodStartId;
      })[0];
      this.periodsOfDayEnd = [this.newRule.periodEnd];
    } else {
      this.periodsOfDayEnd = this.periodsOfDay.filter(function(el) {
        return el.id > periodStartId;
      });
    }
  }

  findConfiltingRule(rule: RedirectRule) {
    let conflictingRule: RedirectRule;
    this.redirectStrategyRules.forEach(function(el) {
      if (
        el.dayOfWeek.id === rule.dayOfWeek.id &&
        el.deviceType.id === rule.deviceType.id &&
        el.numberOfLogin === rule.numberOfLogin
      ) {
        if (
          (rule.periodStart.id <= el.periodStart.id &&
            rule.periodEnd.id > el.periodStart.id) ||
          (rule.periodStart.id < el.periodEnd.id &&
            rule.periodEnd.id >= el.periodEnd.id) ||
          (rule.periodStart.id >= el.periodStart.id &&
            rule.periodEnd.id <= el.periodEnd.id)
        ) {
          if (el.id !== rule.id) {
            conflictingRule = el;
            return;
          }
        }
      }
    });
    return conflictingRule;
  }

  unselectRow() {
    this.selectedStrategy = undefined;
  }

  unselectRuleRow() {
    this.selectedRule = undefined;
  }

  getWebSocketIdentifier(): string {
    return undefined;
  }

  private loadRulesFromResponse(data) {
    this.redirectStrategyRules = data.payload;
  }
}



// WEBPACK FOOTER //
// /home/sgurin/IdeaProjects/cosy/cp-builder/src/app/components/organization/captive-portal/redirect-strategies/redirect-startegies.component.ts